import TinyEditor from "./TinyEditor";

export default TinyEditor;